import type { UpdatePatientInfoQueryApi } from "@/Modules/Models/Api/ClinicalHistory";
import type { PatientInfoUpdateQuery } from "@/Modules/Models/Domain/ClinicalHistory";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { updatePatientInfo } from "@/Services/TherapyApi/ClinicalHistory";
import PatientInfoTransformer, {
  type PatientInfoTransformerType,
} from "@/Modules/Transformers/ClinicalHistory/PatientInfo";

import useClinicalHistoryStore from "@/Modules/ClinicalHistory/Store";
import useAppStore from "@/Modules/App/Store";
import useCustomerStore from "@/Modules/Customers/Store";

import { hasValue } from "@/Utils/Objects";
import { snake } from "@/Utils/Snakelize";
import { danger } from "@/Utils/Debug";

async function updatePatientInfoAH(
  patientInfoId: string,
  patientInfoData: Partial<PatientInfoUpdateQuery>
): Promise<void> {
  const appStore = useAppStore();
  const clinicalHistoryStore = useClinicalHistoryStore();
  const customerStore = useCustomerStore();

  if (!hasValue(customerStore.getCurrentCustomer)) return undefined;

  clinicalHistoryStore.isLoadingPatientInfo = true;

  try {
    const apiQuery = snake(patientInfoData) as Partial<UpdatePatientInfoQueryApi>;
    const patientInfoApi = await updatePatientInfo(
      customerStore.getCurrentCustomer.id,
      patientInfoId,
      apiQuery
    );
    const patientInfoTransformer: PatientInfoTransformerType = PatientInfoTransformer;
    const patientInfoDomain = patientInfoTransformer.toDomain(patientInfoApi);

    clinicalHistoryStore.patientInfo = patientInfoDomain;

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "user.settings.customer.patient_detail.saved_notification",
    });
  } catch (e) {
    danger(e);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    clinicalHistoryStore.isLoadingPatientInfo = false;
  }
}
export default updatePatientInfoAH;
